/* esm.sh - rxjs@7.8.2/dist/esm/internal/operators/flatMap */
import{mergeMap as o}from"rxjs/dist/esm/internal/operators/mergeMap";var r=o;export{r as flatMap};
//# sourceMappingURL=flatMap.mjs.map